import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { createProtectedRoute, handleUnknownRoute } from "../utils/routeUtils";
import Home from "../components/Home";
import Report from "../components/Report";
import Bill from "../components/Bill";
import Stats from "../components/Stats";
import Timeline from "./../components/Timeline/index";
import Performance from "./../components/Performance/index";
import CombineChart from "./../components/Charts/combineChart";
import Detail from "../components/Inventory/Detail";
import Credit from "./../components/Credit/index";
import User from "../components/User";
import Statement from "../components/Inventory/Statement";
import ItemList from "../components/Selectitem/ItemList";
import CostCenter from "../components/Inventory/CostCenter";
import MenuMaster from "../components/MenuMaster/MenuMaster";
import ItemData from "../components/MenuMaster/ItemData";
import Invent from "../components/Invent";
import ReportTable from "../components/ReportTable/reportTable";
import FileUpload from "../components/MenuMaster/FileUpload";
import EditMenu from "../components/MenuMaster/EditMenuData";
import DetailedPurchaseReport from "../components/Invent/DetailedPurchaseReport";
import History from "../components/CustomerPortal";
import ForecastDetails from "../components/SalesPredict/ForecastDetails";
import PredictSales from "../components/SalesPredict";
import VoidToday from "../components/Home/VoidToday";
import ItemReport from "../components/Home/ItemReport";
// import AddCustomerLoyalty from "../components/CustomerPortal/AddCustomerLoyalty";
import EmployeeAnalysis from "../components/Employee/EmployeeAnalysis";
import EmployeeDetails from "../components/Employee/EmployeeDetails";
import AddUnit from "../components/MenuMaster/RecipeCost/AddUnit";
import MenuCostPrice from "../components/MenuMaster/RecipeCost/MenuCostPrice";
import ViewUnitDefinitions from "../components/MenuMaster/RecipeCost/ViewUnitDefinitions";
import SubRecipeCost from "../components/MenuMaster/RecipeCost/SubRecipeCost";
import ViewSubRecipe from "../components/MenuMaster/RecipeCost/ViewSubRecipe";
import MenuEngieering from "../components/MenuEngineering/MenuEngineering";
import InventoryCalculation from "../components/MenuEngineering/InventoryCalculation";
import ReceivedInventory from "../components/MenuEngineering/ReceivedInventory";
import AddOpeningCount from "../components/MenuEngineering/AddOpeningCount";
import AddWastage from "../components/MenuEngineering/AddWastage";
import InventoryHistory from "../components/MenuEngineering/InventoryHistory";
import AddPhysicalCount from "../components/MenuEngineering/AddPhysicalCount";
import CostingAnalysis from "../components/MenuEngineering/CostingAnalysis/CostingAnalysis";
// import FranchiseOrderDetails from "../components/FranchiseOrder/FranchiseOrderDetails";
// import FranchiseOrderHistory from "../components/FranchiseOrder/FranchiseOrderHistory";
// import FranchiseItemList from "../components/FranchiseOrder/ItemList/FranchiseItemList";
// import ItemOrderHistory from "../components/FranchiseOrder/ItemList/ItemOrderHistory";
// import ReconciliationReport from "../components/FranchiseOrder/ReconciliationReport";
// import FranchiseSalesDetails from "../components/FranchiseDetails/FranchiseSalesDetails";
// import IndividualFranchiseDetail from "../components/FranchiseDetails/IndividualFranchiseDetail";
// import FranchiseSalesReport from "../components/FranchiseDetails/FranchiseSalesReport";
// import FranchiseTimeline from "../components/FranchiseDetails/FranchiseTimeline";

const protectedRoutes = [
  createProtectedRoute("/home", <Home />),
  createProtectedRoute("/report", <Report />),
  createProtectedRoute("/bill", <Bill />),
  createProtectedRoute("/customerportal", <History />),
  createProtectedRoute("/stats", <Stats />),
  createProtectedRoute("/timeline", <Timeline />),
  createProtectedRoute("/performance", <Performance />),
  createProtectedRoute("/credit", <Credit />),
  createProtectedRoute("/detail", <Detail />),
  createProtectedRoute("/show-all-chart", <CombineChart />),
  createProtectedRoute("/user", <User />),
  createProtectedRoute("/statement", <Statement />),
  createProtectedRoute("/items", <ItemList />),
  createProtectedRoute("/costcenter", <CostCenter />),
  createProtectedRoute("/menu", <MenuMaster />),
  createProtectedRoute("/itemdata", <ItemData />),
  createProtectedRoute("/inventory", <Invent />),
  createProtectedRoute("/salesreport", <ReportTable />),
  createProtectedRoute("/fileupload", <FileUpload />),
  createProtectedRoute("/editmenudata", <EditMenu />),
  createProtectedRoute("/detailedpurchasereport", <DetailedPurchaseReport />),
  createProtectedRoute("/salespredict", <PredictSales />),
  createProtectedRoute("/forecastdetails", <ForecastDetails />),
  createProtectedRoute("/voidtoday", <VoidToday />),
  createProtectedRoute("/itemsreport", <ItemReport />),
  // createProtectedRoute("/addloyalty", <AddCustomerLoyalty />),
  createProtectedRoute("/employeeanalysis", <EmployeeAnalysis />),
  createProtectedRoute("/employeedetails", <EmployeeDetails />),
  createProtectedRoute("/additemunit", <AddUnit />),
  createProtectedRoute("/menuitemcost", <MenuCostPrice />),
  createProtectedRoute("/viewunitdefinitions", <ViewUnitDefinitions />),
  createProtectedRoute("/subrecipecost", <SubRecipeCost />),
  createProtectedRoute("/viewsubrecipes", <ViewSubRecipe />),
  createProtectedRoute("/menuengineering", <MenuEngieering />),
  createProtectedRoute("/inventorycalculation", <InventoryCalculation />),
  createProtectedRoute("/inventoryreceived", <ReceivedInventory />),
  createProtectedRoute("/addopeningcount", <AddOpeningCount />),
  createProtectedRoute("/addwastage", <AddWastage />),
  createProtectedRoute("/inventoryhistory", <InventoryHistory />),
  createProtectedRoute("/addphysicalcount", <AddPhysicalCount />),
  createProtectedRoute("/costinganalysis", <CostingAnalysis />),
  // createProtectedRoute("/franchiseorders", <FranchiseOrderDetails />),
  // createProtectedRoute("/franchiserequisitionhistory", <FranchiseOrderHistory />),
  // createProtectedRoute("/franchiseitemlist", <FranchiseItemList />),
  // createProtectedRoute("/franchiseitemorderhistory", <ItemOrderHistory />),
  // createProtectedRoute("/reconciliationreport", <ReconciliationReport />),
  // createProtectedRoute("/franchisesalesdetails", <FranchiseSalesDetails />),
  // createProtectedRoute("/individualfranchisedetail", <IndividualFranchiseDetail />),
  // createProtectedRoute("/franchisesalesreport", <FranchiseSalesReport />),
  // createProtectedRoute("/franchisetimeline", <FranchiseTimeline />),
];


const MainRoutes = () => {
  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <Routes>
        {protectedRoutes.map((route) => (
          <Route key={route.path} {...route} />
        ))}

        <Route path="*" element={handleUnknownRoute()} />
      </Routes>
    </>
  );
};

export default MainRoutes;
